import * as React from "react";
import { Classes, Icon } from "@blueprintjs/core";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { validarCNPJ } from "../../utils";
const InputMask = require("react-input-mask");

interface ICnpjInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean
}

export default class CnpjInput extends React.Component<ICnpjInputProps, {}> {
  handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(evt.target.value.replace(/[-\/\.]/g, ""));
  };

  render() {
    let isValid = validarCNPJ(this.props.value);
    EmpresaStore.obs.isValid = isValid

    return (
      <div className={Classes.INPUT_GROUP}>
        <InputMask
          mask="99.999.999/9999-99"
          className={Classes.INPUT + " cnpj-blur"}
          onChange={this.handleChange}
          value={this.props.value}
          disabled={this.props.disabled}
        />
        <Icon
          icon={isValid ? "tick" : "cross"}
          intent={isValid ? "success" : "danger"}
        />
      </div>
    );
  }
}
